import {
  AssetsRoutes,
  InventoryRoutes,
  VendorRoutes,
  GateRegisterRoutes,
  DashboardRoutes,
  MasterWarehouseRoutes,
  GateRoutes,
  UserRoutes,
  CourierPartnerRoutes,
} from '@/Route/AuthRoutes';
import ROLES from '@/Constants/roles';
const { superAdmin, warehouseExecutive, warehouseManager, companyAdmin } = ROLES;

export const sidebarConfig = [
  {
    type: '',
    iconClass: 'ti ti-home',
    name: 'Dashboard',
    path: DashboardRoutes.DASHBOARD,
    roles: [superAdmin, warehouseExecutive, warehouseManager, companyAdmin],
  },

  {
    type: '',
    iconClass: 'ti ti-box',
    name: 'Asset Inventory',
    collapseId: 'inventory',
    path: InventoryRoutes.INVENTORY_LIST,
    exactMatch: true,
    icon: '/assets/icon/inventory.svg',
    activeIcon: '/assets/icon/inventory.svg',
    roles: [superAdmin, warehouseExecutive, warehouseManager, companyAdmin],
    breadcrumbChildren: [
      {
        name: 'Add Inventory',
        path: InventoryRoutes.ADD_INVENTORY,
      },
      {
        name: 'Asset Inventory',
        path: InventoryRoutes.INVENTORY_LIST,
      },
      {
        name: 'Manage Inventory',
        path: InventoryRoutes.MANAGE_INVENTORY,
      },
      {
        name: 'Inventory Stock Transfer',
        path: InventoryRoutes.STOCK_TRANSFER,
      },
    ],
  },

  {
    type: '',
    iconClass: 'ti ti-briefcase',
    name: 'Asset Case',
    collapseId: 'asset_cases',
    path: InventoryRoutes.INVENTORY_CASES,
    icon: '/assets/icon/inventory.svg',
    activeIcon: '/assets/icon/inventory.svg',
    roles: [superAdmin, warehouseExecutive, warehouseManager, companyAdmin],
    breadcrumbChildren: [
      {
        name: 'Asset Case',
        path: InventoryRoutes.INVENTORY_CASES,
      },
    ],
  },

  {
    type: '',
    iconClass: 'ti ti-exchange',
    name: 'Asset Transfer',
    collapseId: 'inventory_transfer',
    path: InventoryRoutes.INVENTORY_TRANSFER,
    icon: '/assets/icon/inventory.svg',
    activeIcon: '/assets/icon/inventory.svg',
    roles: [superAdmin, warehouseExecutive, warehouseManager, companyAdmin],
    breadcrumbChildren: [
      {
        name: 'Asset Transfer List',
        path: InventoryRoutes.INVENTORY_TRANSFER,
      },
      {
        name: 'View Asset Transfer',
        path: InventoryRoutes.VIEW_INVENTORY_TRANSFER,
      },
      {
        name: 'Add Asset Transfer',
        path: InventoryRoutes.ADD_INVENTORY_TRANSFER,
      },
      {
        name: 'View Asset Shipment',
        path: InventoryRoutes.VIEW_ASSET_SHIPMENT,
      },
    ],
  },

  {
    type: 'dropdown',
    iconClass: 'ti ti-file',
    name: 'Master',
    collapseId: 'master',
    roles: [superAdmin, warehouseExecutive, warehouseManager, companyAdmin],
    // path: '/master',
    children: [
      {
        name: 'Assets',
        path: AssetsRoutes.ASSETS_LIST,
        roles: [superAdmin, warehouseExecutive, warehouseManager, companyAdmin],
        icon: '/assets/icon/sku.svg',
        activeIcon: '/assets/icon/sku.svg',
        breadcrumbChildren: [
          {
            name: 'Add Asset',
            path: AssetsRoutes.ADD_ASSETS,
          },
          {
            name: 'Asset List',
            path: AssetsRoutes.ASSETS_LIST,
          },
        ],
      },
      {
        name: 'Vendors',
        path: VendorRoutes.VENDOR_LIST,
        roles: [superAdmin, warehouseExecutive, warehouseManager, companyAdmin],
        icon: '/assets/icon/profile.svg',
        activeIcon: '/assets/icon/profile.svg',
        breadcrumbChildren: [
          {
            name: 'Add Vendor',
            path: VendorRoutes.ADD_VENDOR,
          },
          {
            name: 'Vendors List',
            path: VendorRoutes.VENDOR_LIST,
          },
          {
            name: 'Edit Vendor',
            path: VendorRoutes.EDIT_VENDOR,
          },
        ],
      },
      {
        name: 'Warehouses',
        path: MasterWarehouseRoutes.MASTER_WAREHOUSE_LIST,
        roles: [superAdmin],
        icon: '/assets/icon/inventory.svg',
        activeIcon: '/assets/icon/inventory.svg',
        breadcrumbChildren: [
          {
            name: 'Master Warehouses List',
            path: MasterWarehouseRoutes.MASTER_WAREHOUSE_LIST,
          },
          {
            name: 'Add Master Warehouse',
            path: MasterWarehouseRoutes.ADD_MASTER_WAREHOUSE,
          },
          {
            name: 'View Master Warehouse',
            path: MasterWarehouseRoutes.VIEW_MASTER_WAREHOUSE,
          },
          {
            name: 'Edit Master Warehouse',
            path: MasterWarehouseRoutes.EDIT_MASTER_WAREHOUSE,
          },
        ],
      },
      {
        name: 'Gates',
        path: GateRoutes.GATE_LIST,
        roles: [superAdmin],
        icon: '/assets/icon/gate.svg',
        activeIcon: '/assets/icon/gate.svg',
        breadcrumbChildren: [
          {
            name: 'Gate List',
            path: GateRoutes.GATE_LIST,
          },
          {
            name: 'Add Gate',
            path: GateRoutes.ADD_GATE,
          },
          {
            name: 'View Gate',
            path: GateRoutes.VIEW_GATE,
          },
          {
            name: 'Edit Gate',
            path: GateRoutes.EDIT_GATE,
          },
        ],
      },
      {
        name: 'Users',
        path: UserRoutes.USER_LIST,
        roles: [superAdmin],
        icon: '/assets/icon/user.svg',
        activeIcon: '/assets/icon/user.svg',
        breadcrumbChildren: [
          {
            name: 'User List',
            path: UserRoutes.USER_LIST,
          },
          {
            name: 'Add User',
            path: UserRoutes.ADD_USER,
          },
          {
            name: 'View User',
            path: UserRoutes.VIEW_USER,
          },
          {
            name: 'Edit User',
            path: UserRoutes.EDIT_USER,
          },
        ],
      },
      {
        name: 'Courier Partner',
        path: CourierPartnerRoutes.COURIER_PARTNER_LIST,
        roles: [superAdmin],
        icon: '/assets/icon/profile.svg',
        activeIcon: '/assets/icon/profile.svg',
        breadcrumbChildren: [
          {
            name: 'Courier Partner List',
            path: CourierPartnerRoutes.COURIER_PARTNER_LIST,
          },
        ],
      },
    ],
  },

  {
    type: 'dropdown',
    iconClass: 'ti ti-notebook',
    name: 'Gate Management',
    collapseId: 'gate_register',
    roles: [superAdmin, warehouseExecutive, warehouseManager, companyAdmin],
    children: [
      {
        name: 'Visitors',
        path: GateRegisterRoutes.PERSON_REGISTER,
        roles: [superAdmin, warehouseExecutive, warehouseManager, companyAdmin],
        iconClass: 'ti ti-users',
      },
      {
        name: 'Vehicles',
        path: GateRegisterRoutes.VEHICLE_REGISTER,
        roles: [superAdmin, warehouseExecutive, warehouseManager, companyAdmin],
        iconClass: 'ti ti-truck',
      },
    ],
  },

  // {
  //   type: 'dropdown',
  //   iconClass: 'ti ti-forms',
  //   collapseId: 'forms',
  //   name: 'Forms elements',
  //   path: '/forms',
  //   children: [
  //     { name: 'Form Validation', path: FormElementRoutes.FORM_VALIDATION },
  //     { name: 'Base Input', path: FormElementRoutes.BASE_INPUT },
  //     { name: 'Input Groups', path: FormElementRoutes.INPUT_GROUPS },
  //     { name: 'Input Masks', path: FormElementRoutes.INPUT_MASKS },
  //     { name: 'Floating Labels', path: FormElementRoutes.FLOATING_LABEL },
  //     { name: 'Datetimepicker', path: FormElementRoutes.DATE_TIME_PICKER },
  //     { name: 'Touchspin', path: FormElementRoutes.TOUCH_SPINE },
  //     { name: 'Select2', path: FormElementRoutes.FORM_SELECT },
  //     { name: 'Switch', path: FormElementRoutes.SWITCH },
  //     { name: 'Typeahead', path: FormElementRoutes.TYPEAHEAD },
  //     { name: 'Textarea', path: FormElementRoutes.FORM_TEXTAREA },
  //     { name: 'Clipboard', path: FormElementRoutes.FORM_CLIPBOARD },
  //     { name: 'File Upload', path: FormElementRoutes.FILE_UPLOAD },
  //     { name: 'Default Forms', path: FormElementRoutes.DEFAULT_FORMS },
  //   ],
  // },

  // {
  //   type: 'dropdown',
  //   iconClass: 'ti ti-article-off',
  //   name: 'Error pages',
  //   collapseId: 'error_pages',
  //   path: '/error_pages',
  //   children: [
  //     { name: 'Bad Request', path: ErrorRoutes.ERROR_400 },
  //     { name: 'Forbidden', path: ErrorRoutes.ERROR_403 },
  //     { name: 'Not Found', path: ErrorRoutes.ERROR_404 },
  //     { name: 'Internal Server', path: ErrorRoutes.ERROR_500 },
  //     { name: 'Service Unavailable', path: ErrorRoutes.ERROR_503 },
  //   ],
  // },
  // {
  //   type: 'dropdown',
  //   iconClass: 'ti ti-box-multiple',
  //   name: 'Other pages',
  //   collapseId: 'other_pages',
  //   path: '/other_pages',
  //   children: [
  //     { name: 'Blank', path: OtherRoutes.OTHER_BLANK_PAGE },
  //     { name: 'Maintenance', path: OtherRoutes.MAINTENANCE_PAGE },
  //     { name: 'Coming Soon', path: OtherRoutes.COMING_SOON },
  //     { name: 'Sitemap', path: OtherRoutes.SITE_MAP },
  //     { name: 'Privacy Policy', path: OtherRoutes.PRIVACY_POLICY },
  //     { name: 'Terms & Condition', path: OtherRoutes.TERMS_CONDITION },
  //   ],
  // },
  // {
  //   type: 'dropdown',
  //   title: 'Others',
  //   iconClass: 'ph-duotone ph-number-circle-two',
  //   name: '2 level',
  //   collapseId: 'level',
  //   path: '/level',
  //   children: [
  //     { name: 'Blank', path: BlankRoutes.BLANK_PAGE },
  //     {
  //       name: 'Another level',
  //       path: '/blank',
  //       collapseId: 'level2',
  //       children: [{ name: 'Blank', path: BlankRoutes.ANOTHER_BLANK_PAGE }],
  //     },
  //   ],
  // },

  // {
  //   name: 'Support',
  //   path: 'mailto:teqlathemes@gmail.com.',
  //   iconClass: 'ph-duotone ph-chats',
  // },
];
